// Auto-advance carousels on mobile
(function () {
  function initCarousel(carousel, itemSelector) {
    var cards = carousel.querySelectorAll(itemSelector);
    if (cards.length < 2) return;
    var current = 0;
    setInterval(function () {
      current = (current + 1) % cards.length;
      carousel.scrollTo({ left: cards[current].offsetLeft, behavior: 'smooth' });
    }, 3000);
  }

  function initAllCarousels() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.price-card').forEach(function (el) {
      initCarousel(el, '.single-card');
    });
    var investItem = document.querySelector('#invest .item');
    if (investItem) initCarousel(investItem, '.card');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
})();


/* ---------------------------------------------------------------------------
   Precio del encabezado de cada metal.

   HAY DOS PRECIOS DISTINTOS, y no son el mismo dato con otro nombre:

     function=current      cotización INTERNACIONAL, en US$.
                           Es la que corresponde a la página de inversión.
     function=grain_value  precio de venta de GRANALLA Y LAMINADO, con el
                           margen de la casa. La plata va en pesos y con 10%
                           arriba, a propósito. Corresponde a las páginas de
                           metales para joyería.

   Medido el 2026-09-20: current daba au 140,56 · ag 2,14 · pt 58,06 (US$) y
   grain_value daba au 141 · ag UY$ 95 · pt 73 · pd 53. Antes este archivo
   pedía SIEMPRE grain_value, así que /pages/inversion-oro mostraba el precio
   de granalla donde debía ir el internacional.

   Qué función usa cada página lo decide layout/theme.liquid vía window.LF_COTZ.
   Si falta, el valor por defecto es grain_value, que era el comportamiento
   anterior.

   REPARTO DE IDS (tiene que coincidir con las cuatro secciones):
     chartValue = oro · chartValue2 = plata · chartValue3 = paladio · chartValue4 = platino
   --------------------------------------------------------------------------- */
(function () {
  var CFG = window.LF_COTZ || {};
  var FN  = CFG.fn === 'current' ? 'current' : 'grain_value';
  var KEY = 'pepe';
  var URL = FN === 'current'
    ? 'https://goldapi.deuslab.com/?function=current&elements=au,ag,pt&key=' + KEY
    : 'https://goldapi.deuslab.com/?function=grain_value&key=' + KEY;

  // Las dos funciones devuelven formas distintas. Esto las deja iguales.
  //   grain_value -> { value, currency_symbol, date:"20/09/2026" }
  //   current     -> { grams_price, date:"2026-09-20 17:13:57" }  (siempre US$)
  function norm(m) {
    if (!m) return null;
    if (m.value !== undefined) {
      return { symbol: m.currency_symbol, value: m.value, date: m.date };
    }
    if (m.grams_price !== undefined) {
      return { symbol: 'US$', value: m.grams_price, date: String(m.date || '').slice(0, 10) };
    }
    return null;
  }

  fetch(URL, { method: 'GET' })
    .then(function (res) { return res.json(); })
    .then(function (res) {
      var set = function (id, val) {
        var el = document.getElementById(id);
        if (el) el.textContent = val;
      };
      var d = (res && res.data) || {};
      // metal -> sufijo del id. El paladio solo viene en grain_value.
      [['au', ''], ['ag', '2'], ['pd', '3'], ['pt', '4']].forEach(function (par) {
        var m = norm(d[par[0]]);
        if (!m) return;                      // sin dato: se deja lo que puso el servidor
        var n = par[1];
        set('chartDate' + n,   m.date);
        set('chartSymbol' + n, m.symbol);
        set('chartValue' + n,  ' ' + m.value + '/gr');
      });
    })
    .catch(function () {});   // si falla, queda el valor server-side del metafield
})();
